import React from "react";
import { Link } from "react-router-dom";
import { formatMoney } from "accounting-js";
import IconEdit from "../IconEdit";
import IconDelete from "../IconDelete";
import style from "./SaasItem.module.css";
import { connect } from "react-redux";
import { Badge, Button, Table } from "react-bootstrap";
import SaasBundleOptions from "./SaasBundleOptions";
import { deleteQuoteItem, setQuoteItemQty } from "../../redux/actions";

function SaasItem({
  item,
  itemValidationMap,
  setQuoteItemQty,
  deleteQuoteItem,
  backendValidationMessages
}) {
  const productUrl = `/product/${item.sku}`;

  const hardwareOptions = item.options
    ? item.options
        .map(o => ({
          ...o,
          selections: o.selections.filter(s => s.isHardware)
        }))
        .filter(o => o.selections.length)
    : [];

  const softwareOptions = item.options
    ? item.options
        .map(o => ({
          ...o,
          selections: o.selections.filter(s => s.isSoftware)
        }))
        .filter(o => o.selections.length)
    : [];

  const saasOptions = item.options
    ? item.options
        .map(o => ({
          ...o,
          selections: o.selections.filter(s => s.isSaas)
        }))
        .filter(o => o.selections.length)
    : [];
  
  const backendValidationErrors = backendValidationMessages.filter(err => err.id === item.key && err.selectionIds.length === 0)

  return (
    <Table className={style.root} variant="sm">
      <thead>
        <tr>
          <th className={style.product}>Product</th>
          <th className={style.backorder} />
          <th className={style.availability}>Availability</th>
          <th className={style.msp}>Minimum Sell Price (MSP)</th>
          <th className={style.targetPrice}>Target Price</th>
          <th>SaaS Term</th>
          <th className={style.qty}>Quantity</th>
          <th className={style.lineTotal}>Target Line Total</th>
          <th className={style.financeType}>Finance Type</th>
          <th className={style.actions}>Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr key={item.key}>
          <td>
            <h3 className={style.productName}>
              <Link to={productUrl}>
                {item.name}
                {item.excludeFromMarginSplit && (
                  <Badge variant="danger">Excluded from margin splitting</Badge>
                )}
              </Link>
            </h3>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{item.qty}</td>
          <td>{formatMoney(Number(item.targetPrice + item.saasTargetPrice))}</td>
          <td></td>
          <td>
            <Button
              as={Link}
              to={`${productUrl}?quoteItemKey=${item.key}`}
              variant="link"
            >
              <IconEdit />
            </Button>
            <Button
              variant="link"
              onClick={e => {
                e.preventDefault();
                deleteQuoteItem({ key: item.key });
              }}
            >
              <IconDelete />
            </Button>
          </td>
        </tr>

        {
          backendValidationErrors.map((err, index) => 
            <tr key={`${err.id}-${index}`}>
              <td className="alert-danger" colSpan="10">{err.errorMessage}</td>
            </tr>
          )
        }

        <tr className="table-secondary">
          <td colSpan="10">
            <h4>SaaS in Bundle</h4>
          </td>
        </tr>
        {item.existingTenantLabel !== null && item.existingTenantValue !== null && (
          <tr>
            <td><i>{item.existingTenantLabel}: {item.existingTenantValue}</i></td>
          </tr>
        )}
        <SaasBundleOptions
          parentQty={item.qty}
          options={saasOptions}
          subscriptionTerm={item.subscriptionTerm}
          itemKey={item.key}
        />


        {hardwareOptions.length ? (
          <>
            <tr className="table-secondary">
              <td colSpan="10">
                <h4>Hardware in Bundle</h4>
              </td>
            </tr>
            <SaasBundleOptions
              parentQty={item.qty}
              options={hardwareOptions}
              itemKey={item.key}
            />
          </>
        ) : null}

        {softwareOptions.length ? (
          <>
            <tr className="table-secondary">
              <td colSpan="10">
                <h4>Software in Bundle</h4>
              </td>
            </tr>
            <SaasBundleOptions
              parentQty={item.qty}
              options={softwareOptions}
              itemKey={item.key}
            />
          </>
        ) : null}

        
      </tbody>
    </Table>
  );
}

export default connect(
  state => ({
    itemValidationMap: state.quote.itemValidationMap,
    backendValidationMessages: state.quote.backendValidationMessages
  }),
  {
    deleteQuoteItem,
    setQuoteItemQty
  }
)(SaasItem);
